import type { useLatestOrderAnalytics } from '@src/hooks/useLatestOrderAnalytics';
import { Card, EmptyView, Flex, LoaderTalos, Stack, type CardProps, type Order } from '@talos/kyoko';
import { useTheme } from 'styled-components';
import { TradingCardContent } from './TradingCardContent';

export function TradingCard({
  order,
  isMultileg,
  analytics,
  ...props
}: { order: Order; isMultileg?: boolean; analytics: ReturnType<typeof useLatestOrderAnalytics> } & CardProps) {
  const { latestAnalytics, receivedAnalytics } = analytics;
  const { spacing48 } = useTheme();
  if (latestAnalytics == null) {
    return (
      <Card title="Trading" {...props}>
        <Flex justifyContent="center" alignItems="center" minHeight={spacing48 * (isMultileg ? 4 : 2)}>
          {receivedAnalytics ? <EmptyView>No trading analytics available</EmptyView> : <LoaderTalos />}
        </Flex>
      </Card>
    );
  }

  return (
    <Card title="Trading" {...props}>
      {isMultileg ? (
        <Stack gap="spacing8">
          <TradingCardContent order={order} leg={1} latestAnalytics={latestAnalytics} />
          <TradingCardContent order={order} leg={2} latestAnalytics={latestAnalytics} />
        </Stack>
      ) : (
        <TradingCardContent order={order} latestAnalytics={latestAnalytics} />
      )}
    </Card>
  );
}
